import { $api } from "../generated/client";

type UseGetReturnRequestAverageTimeParams = {
	shopId: string;
	fromTimestamp: number;
	toTimestamp: number;
};

export function useGetReturnRequestAverageTimeSuspense({
	fromTimestamp,
	shopId,
	toTimestamp,
}: UseGetReturnRequestAverageTimeParams) {
	return $api.useSuspenseQuery(
		"get",
		"/shops/{shopId}/statistics/average-times",
		{
			params: { query: { fromTimestamp, toTimestamp }, path: { shopId } },
		},
	);
}
